import { useEffect, useState } from "react";
import moment from "moment";
import { ApiRoutes } from "../../../core/dictionary/api-url";
import axiosService from "../../../core/services/axios-service";
import { ActionDropdown } from "../../../components/designs/action-dropdown";
import { MetricsCard } from "../../../components/designs/matrics-card";
import SideDrawer from "../../../components/designs/side-drawer";
import { Building2, Users, Plus, Delete, Download } from "lucide-react";
import { ListingHeader } from "../../../components/listing-header";
import { SearchAndFiltersListing } from "../../../components/search-filter-listing";
import { RescueRnTable } from "../../../components/designs/rescueRn-table";
import { resourceActionType } from "../../../core/dictionary/global-enums";
import AddNewResource from "./components/add-resource";
import ToastService from "../../../core/services/toaster-service";
import { getBusinessId, isBusinessAdminUser } from "../../../core/services/global-functions";
export default function ResourcesPage() {
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [perPage, setPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortBy, setSortBy] = useState("organizationName");
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchTerm);
  const [isSidedrawerOpen, setIsSidedrawerOpen] = useState(false);
  const [actionType, setActionType] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [resourceToDelete, setResourceToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const isBusinessAdmin = isBusinessAdminUser();

  // Define actions for the ActionDropdown

  const actions = [
    {
      id: "download",
      label: "Download",
      icon: Download,
      value: resourceActionType.download,
    },
    {
      id: "delete",
      label: "Delete Resource",
      icon: Delete,
      value: resourceActionType.delete,
    },
    // {
    //   id: "view",
    //   label: "View organization",
    //   icon: Eye,
    //   value: organisationActionType.view,
    // }
  ];
  const columns = [
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
      cell: (row) => (
        <span style={{ color: "var(--brand-slate)" }}>{row.title}</span>
      ),
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
      cell: (row) => (
        <span style={{ color: "var(--brand-slate)" }}>{row.description}</span>
      ),
    },
    {
      name: "File Type",
      selector: (row) => row.fileType,
      sortable: true,
      cell: (row) => (
        <span style={{ color: "var(--brand-slate)" }}>
          {!!row && !!row.fileType && row.fileType !== ""
            ? row.fileType.toUpperCase()
            : "N/A"}
        </span>
      ),
    },
    {
      name: "Created",
      selector: (row) => row.createdAt,
      sortable: true,
      cell: (row) => (
        <span style={{ color: "var(--brand-slate)" }}>
          {row.createdAt
            ? moment(row.createdAt).format("Do MMM YYYY, h:mm A")
            : ""}
        </span>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <ActionDropdown
          rowData={row}
          actions={actions}
          actionDropClicked={(data) => actionDropClicked(data)}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "80px",
    },
  ];

  const fetchData = async (
    page = 1,
    size = 5,
    sort = "createdAt",
    order = "asc",
    search = ""
  ) => {
    setLoading(true);
    const res = await axiosService.get(ApiRoutes.RESOURCES_LISTING, {
      params: {
        perPage: size,
        currentPage: page,
        sortBy: sort,
        sortOrder: order,
        searchStr: search || "",
      },
    });

    setData(res.data.items || []);
    setTotalRows(res.data.meta.total || 0);
    setLoading(false);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 400); // 400ms debounce

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  useEffect(() => {
    fetchData(currentPage, perPage, sortBy, sortOrder, debouncedSearch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, perPage, sortBy, sortOrder, debouncedSearch]);

  const handlePageChange = (page) => setCurrentPage(page);
  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
  };
  const handleSort = (column, sortDirection) => {
    setSortBy(column.sortField || "createdAt");
    setSortOrder(sortDirection);
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const addNewResource = () => {
    setActionType(resourceActionType.add);
    setIsSidedrawerOpen(true);
    setTimeout(() => {
      setIsSidedrawerOpen(true); // Open the sidedrawer
    }, 100);
  };
  const actionDropClicked = (data) => {
    if (data.action === resourceActionType.delete) {
      setResourceToDelete(data.rowData);
      setShowDeleteModal(true);
      return;
    } else if (data.action === resourceActionType.download) {
      debugger;
      // Trigger file download
      const fileUrl = data.rowData.fileUrl;
      tryDirectDownload(fileUrl);
    }
  };
  // Below code is used for Download the content for the resource from S3
  const tryDirectDownload = (fileUrl) => {
    const a = document.createElement("a");
    a.href = fileUrl;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    a.remove();
  };
  // End of the above code

  // Below code is to delete the resource
  const handleConfirmDelete = async () => {
    if (!resourceToDelete) return;
    setDeleting(true);
    try {
      // derive id field name from object
      const id = resourceToDelete._id;

      // prefer ApiRoutes.DELETE_RESOURCE if defined, otherwise fallback endpoint
      const res = await axiosService.delete(
        `${ApiRoutes.DELETE_RESOURCE}/${id}`
      );

      if (
        res?.data &&
        res.data.message.toUpperCase() === "Content deleted.".toUpperCase()
      ) {
        ToastService.success(
          res.data.message || "Resource deleted successfully."
        );
        // refresh list
        fetchData(currentPage, perPage, sortBy, sortOrder, debouncedSearch);
      } else {
        ToastService.error(res?.data?.message || "Failed to delete resource.");
      }
    } catch (err) {
      ToastService.error("Server error. Please try again.");
    } finally {
      setDeleting(false);
      setShowDeleteModal(false);
      setResourceToDelete(null);
    }
  };
  // End of the above code
  const getNewResourcesCount = (resources) => {
    // Get the first and last day of the previous calendar month
    const startOfLastMonth = moment().subtract(1, "months").startOf("month");
    const endOfLastMonth = moment().subtract(1, "months").endOf("month");
    return resources.filter((resource) =>
      moment(resource.createdAt).isBetween(
        startOfLastMonth,
        endOfLastMonth,
        null,
        "[]"
      )
    ).length;
  };
  return (
    <>
      <ListingHeader
        title={"Resources"}
        breadCrumb={isBusinessAdmin !== true ? [
          { label: "Dashboard", href: "/admin/dashboard" },
          { label: "Resources", href: "/admin/resources" },
        ] : [
          { label: "Dashboard", href: `/business/organizations/${getBusinessId()}/performance` },
          { label: "Resources", href: "/business/resources" },
        ]}
        actions={isBusinessAdmin !== true ? [
          {
            label: "Add New Resource",
            className: "btn btn-rescuern-primary",
            icon: Plus,
            onClick: () => {
              addNewResource();
            },
          },
        ]: []}
      />

      <div className="flex-grow-1 p-4">
        <div className="container-fluid p-0">
          <div className="row g-4 mb-4">
            <div className="col-xl-6 col-lg-6">
              <MetricsCard
                title="Total Resources"
                value={loading ? "--" : totalRows}
                icon={Building2}
              />
            </div>
            <div className="col-xl-6 col-lg-6">
              <MetricsCard
                title="New This Month"
                value={loading ? "--" : totalRows - getNewResourcesCount(data)}
                icon={Users}
              />
            </div>
          </div>
          {/* <div className="mb-4">
            <SearchAndFiltersListing
              placeholder="Search Resources..."
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
            />
          </div> */}
          <RescueRnTable
            data={data}
            loading={loading}
            columns={columns}
            totalRows={totalRows}
            loadingTableText="Loading resources..."
            handleSort={handleSort}
            onChangePage={(page) => handlePageChange(page)}
            handlePerRowsChange={(newPerPage) =>
              handlePerRowsChange(newPerPage)
            }
            perPage={perPage}
          />
        </div>
      </div>
      {/* End of the above code */}
      {/* Below is the code for Delete Confirmation Modal */}
      {showDeleteModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(2,6,23,0.45)",
            zIndex: 1060,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
          }}
        >
          <div
            style={{
              width: 540,
              maxWidth: "100%",
              background: "#fff",
              borderRadius: 12,
              padding: "20px 24px",
              boxShadow: "0 8px 24px rgba(2,6,23,0.08)",
            }}
          >
            <h5 style={{ margin: 0, color: "#003f86", fontWeight: 700 }}>
              Confirm Delete
            </h5>
            <p style={{ color: "#66748c", marginTop: 8 }}>
              Are you sure you want to delete{" "}
              <strong>{resourceToDelete?.title || "this resource"}</strong>?
              This action cannot be undone.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
                marginTop: 16,
              }}
            >
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => {
                  setShowDeleteModal(false);
                  setResourceToDelete(null);
                }}
                disabled={deleting}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleConfirmDelete}
                disabled={deleting}
              >
                {deleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* End of the above code */}
      {/* Below is the sidedrawer component */}
      <SideDrawer
        title={actionType === resourceActionType.add ? "Add New Resource" : ""}
        isOpen={isSidedrawerOpen}
        onClose={() => setIsSidedrawerOpen(false)}
        closeOnOverlay={false}
      >
        <AddNewResource
          onSuccess={(data) => {
            // Handle success (e.g., refresh resource list)
            setIsSidedrawerOpen(false);
            fetchData(
                currentPage,
                perPage,
                sortBy,
                sortOrder,
                debouncedSearch
              );
          }}
        ></AddNewResource>
      </SideDrawer>
      {/* End of the above code */}
    </>
  );
}
